import { Typography } from '@mui/material';
import {
  Procedure as IProcedure,
  ProcedureQuestion,
} from '@norma/shared/types/procedure.type';
import React, { useState } from 'react';
import { Route, useParams } from 'react-router-dom';
import { EssentialInformations } from 'src/components/client/EssentialInformations';
import { theme } from 'src/constants/theme';
import { useAppSelector } from 'src/hooks/store';
import { SentryRoutes } from 'src/routes/sentry';
import { PATH_PREJUDICES, PATH_PROCEDURE } from '../../../routes/paths';
import { victimeSelectors } from '../../../store/selectors';
import { Prejudices } from './Prejudices';
import { Procedure } from './Procedure';
import { ProcedureEdition } from './ProcedureEdition';
import { Procedures } from './Procedures';
interface Props {
  onClickEditVictime: () => void;
  editVictimeOpen: boolean;
}
export type TOpenEditProcedure =
  | {
      answers?: ProcedureQuestion[];
      procedure?: IProcedure;
    }
  | undefined;

export const ClientProcedures: React.FC<Props> = ({
  editVictimeOpen,
  onClickEditVictime,
}) => {
  const { victimeId } = useParams<any>();
  const { victime } = useAppSelector((state) => ({
    victime: victimeId
      ? victimeSelectors.selectById(state, victimeId)
      : undefined,
  }));
  const [openEditProcedure, setOpenEditProcedure] =
    useState<TOpenEditProcedure>(undefined);

  if (!victime) {
    return (
      <Typography
        variant="h6"
        component="h3"
        style={{ paddingTop: theme.spacing(2) }}
      >
        Procedures
      </Typography>
    );
  }

  return (
    <>
      <SentryRoutes>
        <Route
          path="/"
          element={
            <>
              <EssentialInformations
                victime={victime}
                onClickEdit={onClickEditVictime}
                editVictimeOpen={editVictimeOpen}
              />
              <Procedures
                victime={victime}
                setOpenEditProcedure={setOpenEditProcedure}
              />
            </>
          }
        />
        <Route
          path={PATH_PROCEDURE}
          element={
            <Procedure
              victime={victime}
              setOpenEditProcedure={setOpenEditProcedure}
            />
          }
        />
        <Route
          path={PATH_PREJUDICES}
          element={<Prejudices victime={victime} />}
        />
      </SentryRoutes>
      <ProcedureEdition
        victime={victime}
        isSidebar={true}
        isOpen={!!openEditProcedure}
        closeSideBar={() => {
          setOpenEditProcedure(undefined);
        }}
        answers={openEditProcedure?.answers}
        procedure={openEditProcedure?.procedure}
      />
    </>
  );
};
